import type {
  OpportunityEntry as ApiOpportunityEntry,
  Product as ApiProduct,
  Reseller as ApiReseller,
  SearchResult as ApiSearchResult,
} from "randmar-api-client";
import { IDocument } from "../document/Document";
import { Product } from "../product/Product";
import Reseller from "../reseller/Reseller";

type StoreSearchContent = DefaultSearchResult | DocumentSearchResult | ManufacturerBid | Product | Reseller;

type SearchSource = Pick<ApiSearchResult, "ContentType" | "Content"> & {
  Priority?: unknown;
};

export default class SearchResult {
  constructor(
    public contentType: string,
    public priority: string,
    public content: StoreSearchContent,
    public newContent: unknown
  ) { }

  public static convertFrom(source: SearchSource, newContent: unknown): SearchResult {
    let searchResult: StoreSearchContent;

    const contentType = typeof source.ContentType === "string" ? source.ContentType : undefined;
    const rawContent: unknown = source.Content;
    const priority = typeof source.Priority === "string" && source.Priority.trim() !== "" ? source.Priority : "Normal";

    switch (contentType) {
      case "Document":
        searchResult = DocumentSearchResult.convertFrom(rawContent as IDocument); break;
      case "Reseller":
        searchResult = Reseller.convertFrom(rawContent as ApiReseller); break;
      case "Opportunity":
        searchResult = ManufacturerBid.convertFrom(rawContent as ApiOpportunityEntry); break;
      case "Product":
        searchResult = Product.convertFromNewProduct(rawContent as ApiProduct); break;
      default:
        searchResult = new DefaultSearchResult("Eventually something"); break;
    }

    return new SearchResult(contentType || "Unknown", priority, searchResult, newContent ?? rawContent);
  }
}

class DefaultSearchResult {
  constructor(
    public contentTitle: string
  ) { }
}

export class DocumentSearchResult {
  constructor(
    public documentNumber?: string,
    public location?: string,
    public subTotal?: number
  ) { }
  public static convertFrom(source: IDocument): DocumentSearchResult {
    return new DocumentSearchResult(
      source.DocumentNumber || "",
      source.Location,
      source.SubTotal
    );
  }
}

export class ManufacturerBid {
  constructor(
    public active: boolean,
    public lastUpdate: string,
    public bidNumber: string,
    public manufacturerId: string,
    public opportunity: string,
    public startDate: string,
    public endDate: string) { }

  public static convertFrom(source: ApiOpportunityEntry): ManufacturerBid {
    return new ManufacturerBid(
      Boolean(source.Active),
      source.LastUpdate ?? "",
      source.BidNumber ?? "",
      source.ManufacturerId ?? "",
      (source.Opportunity ?? source.OpportunityName) ?? "",
      source.StartDate ?? "",
      source.EndDate ?? ""
    );
  }
}
